export default __webpack_public_path__ + "static/media/Eye.6fb6c9ba.svg";